<template>
  <div class="ActiveTab MonitoringTab">
    <ActiveTabHeader :chargingpoint="chargingpoint">
      <h4>Monitoring</h4>

      <b-form-select v-if="connectionPoints.length > 0" class="mt-1" v-model="selectedPointToShow" :options="pointsForSelection"></b-form-select>
    </ActiveTabHeader>

    <div class="ActiveTab__Content">
      <p v-if="loading" class="text-muted">
        Loading...
      </p>
      <template v-else>
        <div v-if="connectionPoints.length > 0" class="LocatieInformatie__Content">
          <OccupancyRateColumnChart :data="lastMonthsData" title="Bezettingsgraad" />
          <ChargedVolumeColumnChart :data="lastMonthsData" :options="{limit: thresholdChargedVolume}" title="Geladen kWh" />
          <UniqueUsersAreaChart :data="lastMonthsData" title="Unieke gebruikers" />
          <NumberOfSessionsAreaChart :data="lastMonthsData" title="Aantal sessies" />
        </div>
        <p v-else>
          Geen monitoring data
        </p>
      </template>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from "vuex";
import ActiveTabHeader from "@/components/map/sidebar/ActiveTabHeader";
import OccupancyRateColumnChart from "@/components/map/sidebar/Charts/OccupancyRateColumnChart";
import ChargedVolumeColumnChart from "@/components/map/sidebar/Charts/ChargedVolumeColumnChart";
import NumberOfSessionsAreaChart from "@/components/map/sidebar/Charts/NumberOfSessionsAreaChart";
import UniqueUsersAreaChart from "@/components/map/sidebar/Charts/UniqueUsersAreaChart";
import {vtfEvseIdToLocationName} from "@/helpers/ocpi";

const BUSINESS_RULE_VOLUME_RTDM = 250 // TODO:: this comes from the global settings
const LAADPAAL_SELECTED = "laadpaal_is_selected"

export default {
  components: {
    OccupancyRateColumnChart,
    ChargedVolumeColumnChart,
    NumberOfSessionsAreaChart,
    UniqueUsersAreaChart,
    ActiveTabHeader
  },
  data() {
    return {
      lastMonthsData: {},
      selectedPointToShow: LAADPAAL_SELECTED,
      loading: false
    }
  },
  computed: {
    ...mapGetters('planmode', {
      chargingpoint: 'getSelectedChargingpoint', // TODO:: this could be a prop
    }),
    ...mapGetters('monitoring', {
      connectionPoints: 'getSelectedConnectionPoints',
      locationData: 'getSelectedLocationData',
    }),
    ...mapGetters('access',  {
      activeMunicipality: 'getActiveMunicipality', // TODO:: this could be a prop
    }),
    thresholdChargedVolume() {
      if (this.selectedPointToShow === LAADPAAL_SELECTED) {
        return BUSINESS_RULE_VOLUME_RTDM * this.locationData.connectionPoints.length
      }

      return BUSINESS_RULE_VOLUME_RTDM
    },
    pointsForSelection() {
      const inflectedLabel = this.locationData.connectionPoints.length > 1 ? "laadpunten" : "laadpunt"

      const pointsForSelection = [
        { value: LAADPAAL_SELECTED, text: `Laadpaal (${this.locationData.connectionPoints.length} ${inflectedLabel})` },
      ]

      this.locationData.connectionPoints.forEach((entry) => pointsForSelection.push(
        {
          value: entry.evseId,
          text: entry.evseId
        }
      ))

      return pointsForSelection
    }
  },
  watch: {
    selectedPointToShow(selection) {
      this.loadData(selection)
    }
  },
  created() {
    let location = this.chargingpoint.data.properties.evse

    if (this.chargingpoint.data.properties.operator === "Vattenfall") {
      location = vtfEvseIdToLocationName(this.chargingpoint.data.properties.evse)
    }

    this.selectLocation(location)

    // if (this.locationData && this.locationData.connectionPoints.length > 0) {
    //   // if connections are already loaded
    //   this.useAggregatedData()
    //   return
    // }

    this.loading = true

    this.fetchConnectionPointsByLocation(location, this.activeMunicipality)
      .then((response) => {
        if (response.statusCode !== 200) {
          console.error("error fetching connection points:", response.error_description)
          return
        }

        if (response.data.connectionPoints.length === 0) {
          console.info("No connection points were found")
          return
        }

        this.addConnectionPoints({connectionPoints: response.data.connectionPoints})
        this.addLocationData({locationData: response.data.locationData})

        this.useAggregatedData()
      })
    .finally(() => this.loading = false)
  },
  destroyed() {
    this.deselectLocation()
  },
  methods: {
    ...mapMutations('monitoring', [
      'addConnectionPoints',
      'addLocationData'
    ]),
    ...mapActions('monitoring', [
      'selectLocation',
      'deselectLocation',
    ]),
    async fetchConnectionPointsByLocation(location, code) {
      const token = await this.$auth.getTokenSilently();

      const api = await fetch('/monitoring/api/monitoringDataByLocation', {
        method: "POST",
        headers: {
          authorization: 'Bearer ' + token
        },
        body: JSON.stringify({ location, code })
      });

      return await api.json()
    },
    loadData(selection) {
      this.selectedPointToShow = selection

      if (selection === LAADPAAL_SELECTED) {
        this.useAggregatedData()
        return
      }

      const index = this.locationData.connectionPoints.findIndex(connectionPoint => connectionPoint.evseId === selection)

      if (index === -1) {
        this.useAggregatedData()
        return
      }

      this.lastMonthsData = this.locationData.connectionPoints[index].data
    },
    useAggregatedData() {
      this.lastMonthsData = this.locationData?.aggregated
    }
  }
}
</script>

<style lang="scss">
 .MonitoringTab {
   &.ActiveTab {
      overflow-x: hidden;
   }

   &__SelectDropdown {
     position: absolute;
     right: 60px;
     top: 8px;
   }
 }

 .ggl-tooltip {
   white-space: nowrap;
   padding: 5px;
 }

 // fix flickering tooltip: https://github.com/google/google-visualization-issues/issues/2162
 div.google-visualization-tooltip { pointer-events: none }
 svg > g > g:last-child { pointer-events: none }
 svg > g:last-child > g:last-child { pointer-events: none }
</style>